import * as React from "react";

React.lazy(() =>
    import(
        /* webpackMode: "eager" */ "@omni/components/components/Modals/GuaranteeNoticeModal/guaranteeNoticeModal"
    ).then((module) => ({ default: module.GuaranteeNoticeModal }))
);
